import React, {Fragment} from 'react';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import LazyLoadImageComponent from "common/components/LazyLoadImage";
import { t } from 'translates';

function Push(props) {

  const {
    title,
    stripped_tags_title,
    description,
    image,
    video,
    cta,
    created_date
  } = props;

  const JsonLd = ({ data }) => (
    <script type="application/ld+json">
      {JSON.stringify(data)}
    </script>
  );

  const jsonLD = {
    "@context":"http:\/\/schema.org",
    "@type": "VideoObject",
    "name": stripped_tags_title,
    "description": description,
    "uploadDate": created_date,
    "duration": video.duration,
    "contentUrl": video.src,
  };

  return (
    <div className='product-push' >
      <div className="product-push__media">
        {video && video.src && (
          <Fragment>
            <LazyLoadComponent>
            <video autoPlay muted loop playsInline >
              <source src={video.src} type={video.mime_type} />
            </video>
            </LazyLoadComponent>
            <JsonLd data={jsonLD} />
          </Fragment>
        )}
        {image && image.uri && (
          <picture>
            <source srcSet={image.image_desktop} media="(min-width: 1024px)" />
            <LazyLoadImageComponent
              src={image.uri}
              alt={image.alt}
            />
          </picture>
        )}
      </div>
      <div className="product-push__body">
        <div className="product-push__body-top">
          <h3 className='product-push__title' dangerouslySetInnerHTML={{__html: title}}/>
          <span className="product-push__description">
            {description}
          </span>
        </div>
        {cta.url && (
          <Fragment>
            <a href={cta.url} className='product-push__cta-desktop'/>
            <a href={cta.url} className='product-push__cta'>
              {cta.label ? cta.label : t('View all', DT_SESSIONSNEW)}
            </a>
          </Fragment>
        )}
      </div>
    </div>

  );
}

export default  Push;
